import type { ODataQueryOptions } from '@experiences/interfaces';
import buildQuery from 'odata-query';

import {
    get,
    post,
} from '../utility/Requests';

export const AX_DIRECTORY_ID = 'd4b048e8-2e23-49c1-975f-f741073d08a4';
export enum ORCH_ROLE {
    ALLOW_TO_BE_AUTOMATION_USER_ROLE = 'Allow to be Automation User',
}
const ORCH_URL = '/api/orchestrator/roles';

export type Role = {
    Name: string;
    DisplayName: string;
    Type: 'Folder' | 'Tenant';
    Groups: null;
    IsStatic: boolean;
    IsEditable: boolean;
    Id: number;
};

type RoleObject = {
    '@odata.count': number;
    '@odata.context': string;
    value: Role[];
};

export async function getOrchRoleExistsForGroup(urlParams: { groupId: string; tenantId?: string; role: string }) {
    const res = await get<string>(ORCH_URL, { urlParams });
    return res;
}

export async function setOrchRoleForGroup(body: { groupId: string; tenantId?: string; role: string }) {
    return await post<string[]>(ORCH_URL, { body });
}

export async function getRoles(
    urlParams: { accountLogicalName: string; tenantName: string },
    queryOptions: ODataQueryOptions
) {
    const {
        accountLogicalName, tenantName,
    } = urlParams;
    const endpoint = `${ORCH_URL}/${accountLogicalName}/${tenantName}${buildQuery(queryOptions)}`;

    return await get<RoleObject>(endpoint);
}

export async function assignRoleToFolder(body: {
    accountLogicalName: string;
    tenantName: string;
    directoryIdentifier: string;
    roleId: number;
    folderId: number;
}) {
    return await post(`${ORCH_URL}/assignRoleToFolder`, { body });
}
